window.Vue = require('vue');
import store from './store'
import { BootstrapVue, IconsPlugin, BPaginationNav } from 'bootstrap-vue';
import VueRouter from 'vue-router';
import VueLazyload from 'vue-lazyload';
import Loading from 'vue-loading-overlay';
import Multiselect from 'vue-multiselect';
import VueCookies from 'vue-cookies';
import VueSocialSharing from 'vue-social-sharing'
import VueClipboard from 'vue-clipboard2'
import vClickOutside from "v-click-outside"
import { VueReCaptcha } from 'vue-recaptcha-v3'

Vue.use(BootstrapVue);
Vue.use(VueCookies);
Vue.use(IconsPlugin);
Vue.use(VueRouter);
Vue.use(VueLazyload);
Vue.use(Loading);
Vue.use(require('vue-moment'));
Vue.use(VueSocialSharing);
Vue.use(VueClipboard)
Vue.use(vClickOutside)
Vue.use(VueReCaptcha, { siteKey: process.env.MIX_GOOGLE_RECAPTCHA_SITE_KEY })

Vue.component('new-applications', require('./components/NewApplicationsComponent.vue').default);
Vue.component('top-applications', require('./components/TopApplicationsComponent.vue').default);
Vue.component('collection-page', require('./components/CollectionPageComponent.vue').default);
Vue.component('collection-detail', require('./components/CollectionDetailPageComponent.vue').default);

Vue.component('main-page', require('./components/MainPageComponent.vue').default);
Vue.component('blog-page', require('./components/BlogComponent.vue').default);
Vue.component('privacy-page', require('./components/PrivacyPageComponent.vue').default);
// Vue.component('dashboard', require('./components/DashboardComponent.vue').default);

Vue.component('multiselect', Multiselect);
Vue.component('b-pagination-nav', BPaginationNav)

//custom
Vue.component('instagram-widget', require('./components/custom/InstagramWidgetComponent.vue').default);
Vue.component('social-share', require('./components/custom/SocialShareComponent.vue').default);


const router = new VueRouter({
    mode: 'history',
});

const app = new Vue({
    el: '#app',
    router,
    store: store
});



